module.exports = __webpack_public_path__ + "img/en.e37023e5.svg";